export const theme = {
  background: {
    main: "#f0f2f2",
  },
  primary: {
    main: "#3D68FF",
    light: "#f2fbff",
    dark: "#3D68FF",
  },
  secondary: {
    main: "#949494",
    light: "#f5f5f5",
    medium: "#333333",
    dark: "#333333",
  },
  form: {
    main: "#eef3f7",
    light: "#f5f8fa",
    medium: "#dddddd",
    dark: "#e4e6ef50",
  },
  success: {
    main: "#8be68b",
    light: "#E8FFF3",
    dark: "#47be85",
    medium: "#28D94F",
  },
  black: {
    main: "rgba(0,0,0,0.3)",
    medium: "rgba(0,0,0,0.6)",
    dark: "#000",
    light: "rgba(0,0,0,0.06)",
  },
  white: {
    main: "#fff",
    light: "#edf1ff",
    dark: "#dfe3f6",
  },
  error: {
    main: "#e34a29",
    light: "#FFF5F8",
    medium: "#FB5D5D",
    dark: "#FC0707",
  },
  info: {
    main: "#095379",
    light: "#26adf8",
    dark: "#313649",
    medium: "#890fe9",
  },
  warning: {
    main: "yellow",
    light: "#ffd47f",
    dark: "#d4c140",
  },
  transparent: "transparent",
};
